import { useMemo } from 'react';

import { useTranslations } from '@heidi/runtime/i18n';

/**
 * Hook to get translated duration text for use with PriceBuilder.
 * Returns memoized duration text object with all duration variants.
 */
export const useDurationText = () => {
  const { t } = useTranslations();

  return useMemo(
    () => ({
      monthShort: t('shared.duration.monthShort'),
      monthFull: t('shared.duration.monthFull'),
      yearShort: t('shared.duration.yearShort'),
      yearFull: t('shared.duration.yearFull'),
    }),
    [t]
  );
};
